<app-header (outDate)="setDateNow($event)"></app-header>

<div id="dashboard">
  <div class="container-fluid">
    <div class="box">
      <div class="row">
        <div class="col" *ngFor="let menu of chartsData.total; let i = index">
          <div class="content" (click)="hideShowSeries($event, i)">
            <h5>{{ menu.name }} <span class="{{ icnClass[i] }}"></span></h5>

            <i>{{ menu.total }}</i>

            <small>ver gráfico</small>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="box">
          <h6>QUANTIDADE DE OS</h6>

          <div [chart]="chart"></div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="box no-marg-right">
          <h6>SATISFAÇÃO DOS ATENDIMENTOS</h6>

          <div class="starRating">
            <span>{{ starsRating.initialStars }}</span>
            <div class="stars">
              <ngx-stars
                [initialStars]="starsRating.initialStars"
                [readonly]="true"
                [size]="2"
                [color]="starsRating.initialStars == 0 ? '#999' : '#7ed321'"
              >
              </ngx-stars>
            </div>
          </div>
        </div>
      </div>

      <div class="col">
        <div class="box no-marg-left">
          <h6>TEMPO MÉDIO PARA ATENDIMENTO</h6>

          <div class="serviceTime">
            <span>{{ serviceTime }}</span>

            <small>horas</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
